import type { TFunction } from "i18next";

// Rejection value / error code used for HTTP 429 (rate limit reached)
export const TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS";

/**
 * Text for a failed request in a form: the rate-limit message for 429,
 * otherwise the page's own text for the code, or the given fallback.
 */
export function requestErrorText(
  t: TFunction,
  code: string | null | undefined,
  pageErrorsKey?: string,
): string {
  if (code === TOO_MANY_REQUESTS) return t("Errors.TOO_MANY_REQUESTS");
  const fallback = t("Errors.UNKNOWN");
  if (!code || !pageErrorsKey) return fallback;
  return t(`${pageErrorsKey}.${code}`, { defaultValue: fallback });
}
